module.exports = __webpack_public_path__ + "static/media/addShiftToAbsenceUnsel.21fb4718.svg";